import React from 'react'
import Button from '@components/Button'
import useRequestAuthenticate from '@hooks/useRequestAuthenticate'
import useSaveSessionEmail from '@hooks/useSaveSessionEmail'
import useState from '@hooks/useState'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import Register from '@page-components/Auth/CodeLogin/Register'
import Login from '@page-components/Checkout/Checkout/Profile/Login'
import saveJWT from '@providers/apollo/saveJWT'
import {Field, Form} from 'simple-react-form'

import SessionPhone from './SessionPhone'

import styles from './styles.module.css'

export default function LoginAtCheckout(props) {
  const {preferences, optionalPhone} = props

  const [errorMessage, setErrorMessage] = useState<void | string>()
  const [email, setEmail] = useState<string>()
  const requestAuthenticate = useRequestAuthenticate()
  const missingEmail = Boolean(!email || !email.trim())
  const saveSessionEmail = useSaveSessionEmail(preferences, requestAuthenticate, setErrorMessage)

  if (!preferences.sessionEmail) {
    return (
      <div>
        <Form state={{email}} onChange={({email}) => setEmail(email.trim())}>
          <Field
            fieldName="email"
            fieldType="email"
            label="Email"
            placeholder="Escribe tu email"
            type={Text}
            errorMessage={errorMessage || ''}
            onBlur={() => saveSessionEmail(email)}
            onEnter={() => saveSessionEmail(email)}
          />
        </Form>
        <br />
        <Button disabled={missingEmail}>Guardar</Button>
      </div>
    )
  }

  if (preferences.sessionEmail && !preferences.sessionEmailHasAccount) {
    return (
      <div>
        <Register
          changeEmail={() => saveSessionEmail(null)}
          email={preferences.sessionEmail}
          onSuccess={session => {
            saveJWT(session)
          }}
        />
      </div>
    )
  }

  if (preferences.sessionEmail) {
    return (
      <div>
        <Text label="Email" disabled value={preferences.sessionEmail} />
        <div className="description">
          ¿Quieres usar otro email? <a onClick={() => saveSessionEmail(null)}>Cambiar email</a>
        </div>
        <br />
        <div className={styles.connectJustoAccount}>
          ¿Quieres conectar tu cuenta Justo para usar tus datos de pago, teléfono y direcciones?{' '}
          <a onClick={() => requestAuthenticate(preferences.sessionEmail)}>Conectar</a>
        </div>
        <br />
        <SessionPhone preferences={preferences} optionalPhone={optionalPhone} />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <Login showRedBorder={true} onExistingEmailAccountDetected={saveSessionEmail} />
    </div>
  )
}
